import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { deliveryRatioEndpointIds } from 'root/src/shared/deliveryRatio/deliveryRatio.constants';
export const getDropParticipatingCreatorsEndpoint = {
    [deliveryRatioEndpointIds.GET_DROP_PARTICIPATING_CREATORS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: [AuthGroup.Admin],
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
            },
            required: ['dropId'],
        },
        endpointType: otherEndpointType,
    },
};
